






























































































	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

	import { mapState, mapGetters } from 'vuex'
	import '@/plugins/echo';

    @Component({
		name: 'DasboardCoreDrawer',
		computed: {
			...mapState('drawer', ['barColor', 'barImage']),
			...mapGetters('auth', ['user', 'admin', 'roles'])
		},
	})

	export default class Drawer extends Vue {

		@Prop({ type: Boolean, default: false })
		public expandOnHover: any;

		public barColor!: any;
		public barImage!: any;
		public user!: any;
		
		public items: any[] = [
			{
				icon: 'mdi-account',
				title: 'profile.my-profile',
				to: '/profile',
				roles: ['Super Admin', 'Admin', 'Parent', 'Babysitter']
			},
			{// ADMIN ROUTES START
				title: 'sessions.area',
				icon: 'mdi-clipboard-outline',
				group: '/a/sessions',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-table-plus',
						title: 'sessions.create.title',
						to: 'new',
						roles: ['Super Admin', 'Admin']
					},
					{
						icon: 'mdi-table',
						title: 'sessions.all.title',
						to: 'all',
						roles: ['Super Admin', 'Admin']
					}
				]
			},
			{
				icon: 'mdi-account-group',
				title: 'users.area',
				group: '/a/users',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-table-account',
						title: 'users.all.title',
						to: 'all',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-auto-fix',
						title: 'users.wizard.title',
						to: 'user-wizard',
						roles: ['Super Admin', 'Admin'],
					}
				]
			},
			{
				icon: 'mdi-human-male-female',
				title: 'families.area',
				group: '/a/families',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-table-large',
						title: 'families.all.title',
						to: 'all',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-table-large',
						title: 'families.reports.title',
						to: 'reports',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-credit-card-plus',
						title: 'families.add-balance.title',
						to: 'add-balance',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-credit-card-minus',
						title: 'families.sub-balance.title',
						to: 'sub-balance',
						roles: ['Super Admin', 'Admin'],
					}
				]
			},
			{
				icon: 'mdi-human-female-boy',
				title: 'babysitters.area',
				group: '/a/babysitters',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-table-large',
						title: 'babysitters.all.title',
						to: 'all',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-credit-card-plus',
						title: 'add-balance',
						to: 'add-balance',
						roles: ['Super Admin', 'Admin']
					},
					{
						icon: 'mdi-credit-card-minus',
						title: 'make-payment',
						to: 'make-payment',
						roles: ['Super Admin', 'Admin']
					}
				]
			},
			// {
			// 	icon: 'mdi-bell',
			// 	title: 'notification-section',
			// 	group: '/a/notifications',
			// 	roles: ['Super Admin', 'Admin'],
			// 	children: [
			// 		{
			// 			icon: 'mdi-bell',
			// 			title: 'notifications',
			// 			to: 'all',
			// 			roles: ['Super Admin', 'Admin'],
			// 		},
			// 	]
			// },
			{
				icon: 'mdi-bank',
				title: 'transaction-section',
				group: '/a/transactions',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-bank-transfer',
						title: 'transactions',
						to: 'all',
						roles: ['Super Admin', 'Admin'],
					},
					// {
					// 	icon: 'mdi-book-open-page-variant',
					// 	title: 'accounting',
					// 	to: 'accounting',
					// 	roles: ['Super Admin', 'Admin'],
					// },
					{
						icon: 'mdi-book-open-page-variant',
						title: 'family-overview',
						to: 'family-overview',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-book-open-page-variant',
						title: 'babysitter-overview',
						to: 'babysitter-overview',
						roles: ['Super Admin', 'Admin'],
					}
				]
			},
			{
				icon: 'mdi-shape',
				title: 'other',
				group: '/a/other',
				roles: ['Super Admin', 'Admin'],
				children: [
					{
						icon: 'mdi-city',
						title: 'cities',
						to: 'cities',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-translate',
						title: 'languages',
						to: 'languages',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-earth',
						title: 'nationalities',
						to: 'nationalities',
						roles: ['Super Admin', 'Admin'],
					},
					{
						icon: 'mdi-paw',
						title: 'pets',
						to: 'pets',
						roles: ['Super Admin', 'Admin'],
					},
				]

			},
			{
				icon: 'mdi-cog',
				title: 'settings',
				to: '/a/settings',
				roles: ['Super Admin', 'Admin'],
			},
			{
				icon: 'mdi-update',
				title: 'activity',
				to: '/a/activity',
				roles: ['Super Admin', 'Admin'],
			}, 
			// ADMIN ROUTES END
			
			// BABYSITTER ROUTES START
			{ 
				icon: 'mdi-card-account-details',
				title: 'profile-babysitter',
				to: '/b/profile',
				roles: ['Babysitter']
			},
			{ 
				icon: 'mdi-file-document-multiple',
				title: 'documents',
				to: '/b/documents',
				roles: ['Babysitter']
			},
			{
				title: 'sessions.area',
				icon: 'mdi-clipboard-outline',
				group: '/b/sessions',
				roles: ['Babysitter'],
				children: [
					{
						icon: 'mdi-archive',
						title: 'sessions.archive.title',
						to: 'archive',
						roles: ['Babysitter']
					}
				]
			},
			// BABYSITTER ROUTES END
			
			// FAMILY ROUTES START
			{ 
				icon: 'mdi-card-account-details',
				title: 'profile-family',
				to: '/p/profile',
				roles: ['Parent']
			}, 
			{
				title: 'sessions.area',
				icon: 'mdi-clipboard-outline',
				group: '/p/sessions',
				roles: ['Parent'],
				children: [
					{
						icon: 'mdi-archive',
						title: 'sessions.archive.title',
						to: 'archive',
						roles: ['Parent']
					}
				]
			},
			/* { 
				icon: 'mdi-calendar-plus',
				title: 'reservation',
				to: '/reservation',
				roles: ['Parent']
			},  */
			// FAMILY ROUTES END
			
		]
		
		get drawer () {
			return this.$store.state.drawer.showDrawer
		};

		set drawer (val: any) {
			this.$store.dispatch('drawer/setDrawer', val);
		};

		get computedItems(): any {
			return this.items.map(this.mapItem);
		};

		get profile(): any {
			return {
				avatar: true,
				title: this.$t('avatar')
			}
		};
		
		@Watch('$vuetify.breakpoint.smAndDown')
		onPropertyChanged(value: any) {
			this.$emit('update:expandOnHover', !value);
		}

		public mapItem(item: any) { 
			return {
				...item,
				children: item.children ? item.children.map(this.mapItem) : undefined,
				title: this.$t(item.title),
			}
		};

		public mounted() 
		{
			/* this.$echo.private('session').listen('BabysittingSessionEvents\\SessionEvent', (e: any) => {
				console.log(e.babysittingSession);
				
				commit(types.UPDATE_SESSION, e.babysittingSession);
       	 	}) */
			/* this.$echo.private('session').listen('BabysittingSessionEvents\\SessionEvent', (e: any) => {
				console.log(e.babysittingSession);
			}) */
		}

		public beforeDestroy()
		{
			/* this.$echo.leave('session'); */
		}
	}
